import { CustomCard } from '@/components/custom-card';
import { SubheadingSm } from '@/components/custom-titles';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { formatNumber } from '@/utils/numberFormat';
import { useTranslation } from 'react-i18next';
import { BREAKDOWN_BAR_COLORS } from '../constants';

export interface BreakdownRow {
  id: string | number;
  name: string;
  value: number;
}

interface InsuranceRegionBreakdownProps {
  title: string;
  data?: BreakdownRow[];
  isLoading?: boolean;
  className?: string;
  /** Nechta qator ko'rsatilsin. */
  limit?: number;
}

/** Hududlar kesimida tanlangan ko'rsatkich. */
export const InsuranceRegionBreakdown = ({
  title,
  data,
  isLoading,
  className,
  limit = 10,
}: InsuranceRegionBreakdownProps) => {
  const { t } = useTranslation();

  const rows = (data || [])
    .slice()
    .sort((a, b) => b.value - a.value)
    .slice(0, limit);

  /** Chiziq uzunligi eng katta qiymatga nisbatan hisoblanadi. */
  const maxValue = Math.max(...rows.map((row) => row.value), 0);

  return (
    <CustomCard className={cn('flex w-full flex-col gap-4', className)}>
      <SubheadingSm title={title} />

      {isLoading ? (
        <div className="flex h-[320px] items-center justify-center">
          <div className="progress" />
        </div>
      ) : rows.length ? (
        <div className="flex flex-col gap-4">
          {rows.map((row, index) => (
            <div key={row.id} className="flex flex-col gap-1.5">
              <div className="flex items-center justify-between gap-3">
                <span className="text-xs font-normal text-foreground">
                  {row.name}
                </span>
                <span className="text-xs font-medium text-foreground opacity-70">
                  {formatNumber(row.value)}
                </span>
              </div>

              {/* Chiziq uzunligi eng katta qiymatga nisbatan. */}
              <Progress
                className="h-1 bg-white/10"
                value={maxValue ? (row.value / maxValue) * 100 : 0}
                indicatorClassName={
                  BREAKDOWN_BAR_COLORS[index % BREAKDOWN_BAR_COLORS.length]
                }
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex h-[320px] items-center justify-center text-sm text-muted-foreground">
          {t('no_data')}
        </div>
      )}
    </CustomCard>
  );
};
